import React, { useEffect, useState } from "react";

import { useGetDigitalAgronomistPreferences, useNavigate, useTranslation, useUserContext } from "utils";

import { CropRecommendationResponse, NavigationSplitViewOnTileClickedProps } from "models";

import { AntModal, Flex, MainPage } from "components";

import { Preference, Preferences } from "pages/app/digital-agronomist/components/Preferences.tsx";
import Timeline from "pages/app/digital-agronomist/components/Timeline.tsx";
import { UpdateDigitalAgronomistPreferencesForm } from "pages/app/digital-agronomist/components/UpdateDigitalAgronomistPreferencesForm.tsx";
import { convertResponseToPreference } from "pages/app/digital-agronomist/utils";

export const DigitalAgronomistPage = () => {
  const { t } = useTranslation("digitalAgronomist");
  const { user } = useUserContext();
  const navigate = useNavigate();

  const [preferences, setPreferences] = useState<Preference[]>([]);
  const [showEditModal, setShowEditModal] = useState<boolean>();
  const [selectedPreferencePosition, setSelectedPreferencePosition] = useState<NavigationSplitViewOnTileClickedProps>();

  const { data, isPending } = useGetDigitalAgronomistPreferences({ user });
  const mainCropsPreferencesCompleted = Object.entries(data || {})?.length > 0 && data?.cropRecommendations?.length === data?.preferences?.mainCropsNumber;

  const handlePreferenceClick = (position: NavigationSplitViewOnTileClickedProps) => {
    setSelectedPreferencePosition(position);
    setShowEditModal(true);
  };

  useEffect(() => {
    if (isPending) return;
    if (data && mainCropsPreferencesCompleted) {
      const preferences = convertResponseToPreference(data as CropRecommendationResponse, t, handlePreferenceClick);
      setPreferences(preferences);
    } else {
      navigate("/side-crop-recommender/onboarding");
    }
  }, [data, isPending, mainCropsPreferencesCompleted, navigate, t]);

  return (
    <MainPage
      fullWidth
      pageName="digital-agronomist-page"
      loading={isPending || !data || !mainCropsPreferencesCompleted}
      share={{ title: t("digitalAgronomist") }}
      showMobileAlert
    >
      <div className="digital-agronomist">
        <Flex className="da-timeline" vertical={true}>
          <div className="da-timeline header">
            <h3 className="margin-left-200 margin-bottom-100">{t("digitalAgronomist")}</h3>
            <Preferences title={t("farmProfile")} preferences={preferences} />
          </div>
          <div className="da-timeline body">
            <Timeline />
          </div>
        </Flex>
        <AntModal
          className="digital-agronomist-modal"
          data-testid="digital-agronomist-modal-edit-preferences"
          open={showEditModal}
          footer={null}
          onCancel={() => setShowEditModal(false)}
          destroyOnHidden={true}
          transitionName=""
        >
          {selectedPreferencePosition && (
            <UpdateDigitalAgronomistPreferencesForm selectedPreferencePosition={selectedPreferencePosition} onFinish={() => setShowEditModal(false)} />
          )}
        </AntModal>
      </div>
    </MainPage>
  );
};
